<template>
  <div class="q-loading" :class="[end ? 'loading-opacity' : '']">
    <div class="loading-content">
      <div class="title">体质评估报告生成中..</div>
      <div class="circle">
        <van-circle
          v-model="currentRate"
          :rate="rate"
          :speed="speed"
          :text="text"
          :stroke-width="60"
          layer-color="rgba(0,0,0,0.03)"
          color="#81EF5F"
          size="87px"
        />
      </div>
      <div class="text">
        <span class="iconfont icon-jiazai"></span><span>正在分析您的方案</span>
      </div>
      <div class="desc">1000+权威营养师联合编审</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentRate: 0,
      rate: 100,
      speed: 50,
      end: false
    }
  },
  computed: {
    text() {
      return this.currentRate.toFixed(0) + '%'
    }
  },
  created() {
    this.init()
  },
  mounted() {},
  methods: {
    init() {
      this.currentRate = 0
      setTimeout(() => {
        this.end = true
        setTimeout(() => {
          this.$emit('end')
        }, 1000)
      }, (this.rate / this.speed) * 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
.q-loading {
  transition: opacity 1s linear;
  text-align: center;
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 999;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;

  ::v-deep .van-circle__text {
    font-size: 22px;
    font-family: DINPro-Bold, DINPro;
    font-weight: bold;
    color: #0d0d0d;
    line-height: 30px;
  }

  .title {
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #0d0d0d;
    line-height: 28px;
    margin-bottom: 29px;
  }

  .circle {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 36px;
  }

  .text {
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #0d0d0d;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .iconfont {
      width: 10px;
      height: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 4px;
      color: rgba(0, 0, 0, 0.6);
      font-size: 14px;
      animation: Myrotate 2s linear infinite;
      transform-origin: center center;
    }
  }

  .desc {
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(13, 13, 13, 0.3);
    line-height: 18px;
  }
}

.loading-opacity {
  opacity: 0;
}

@keyframes Myrotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
